import React, { useEffect, useMemo, useState } from "react";
import Sidebar from "../../../components/admin/sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import useDash from "../../../assets/css/dash.module.css";
import { FontColor, FourGround } from "../../../assets/js/theme";
import { useTranslation } from "react-i18next";
import Loader from "../../../components/common/Loader";
import { ArrowClockwise, FilterCircle } from "react-bootstrap-icons";
import Table from "../../../components/table/Table";
import Footer from "../../../components/admin/footer/Footer";
import {
  getBandwidthResellerByISPOwner,
  resellerBandwidthBillReport,
} from "../../../features/apiCallReseller";
import { useDispatch, useSelector } from "react-redux";
import useISPowner from "../../../hooks/useISPOwner";
import moment from "moment";
import { Accordion } from "react-bootstrap";
import DataFilter from "../../common/DataFilter";
import useDataState from "../../../hooks/useDataState";

const ResellerBillCollection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const filterInputPermission = {
    bandwidthReseller: true,
  };

  //---> Get filtered dataset from useDataState hook
  const { filterOptions, setFilterOption } = useDataState();

  //---> Get user & current user data form useISPOwner hooks
  const { ispOwnerId } = useISPowner();

  //---> Get ispOwner bandwidth bill report form redux store
  const reports = useSelector((state) => state?.reseller?.bandwidthBill);

  //---> Get ispOwner bandwidth packages form redux store
  const resellers = useSelector((state) => state?.reseller?.bandwidthReseller);

  //---> Local State
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeKeys, setActiveKeys] = useState("");
  const [collectionReport, setCollectionReport] = useState([]);

  useEffect(() => {
    !resellers?.length &&
      getBandwidthResellerByISPOwner(dispatch, ispOwnerId, setLoading);

    !reports?.length &&
      resellerBandwidthBillReport(dispatch, ispOwnerId, setIsLoading);
  }, []);

  useEffect(() => {
    if (reports) {
      setCollectionReport(reports);
    }
  }, [reports]);

  const reloadHandler = () => {
    resellerBandwidthBillReport(dispatch, ispOwnerId, setIsLoading);
  };

  const findResellerDataByResellerId = (resellerId) => {
    const reseller = resellers?.find((value) => value._id === resellerId);

    return reseller;
  };

  const columns = useMemo(
    () => [
      {
        width: "5%",
        Header: "#",
        id: "row",
        accessor: (row) => Number(row.id + 1),
        Cell: ({ row }) => <strong>{Number(row.id) + 1}</strong>,
      },
      {
        width: "12%",
        Header: t("reseller"),
        accessor: "reseller",
        Cell: ({ cell: { value } }) => (
          <p>{resellers && findResellerDataByResellerId(value)?.name}</p>
        ),
      },
      {
        width: "12%",
        Header: t("month"),
        accessor: "invoice.month",
      },
      {
        width: "10%",
        Header: t("amount"),
        accessor: "amount",
      },
      {
        width: "10%",
        Header: t("date"),
        accessor: "createdAt",
        Cell: ({ cell: { value } }) => {
          return moment(value).format("YYYY/MM/DD hh:mm A");
        },
      },
    ],
    [t, resellers]
  );

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />

      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div>{t("collection")}</div>
                  <div className="d-flex justify-content-center align-items-center">
                    <div
                      onClick={() => {
                        if (!activeKeys) {
                          setActiveKeys("filter");
                        } else {
                          setActiveKeys("");
                        }
                      }}
                      title={t("filter")}
                    >
                      <FilterCircle className="addcutmButton" />
                    </div>

                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title={t("refresh")}
                          onClick={() => reloadHandler()}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </FourGround>

              <FourGround>
                <div className="mt-2">
                  <Accordion alwaysOpen activeKey={activeKeys}>
                    <Accordion.Item eventKey="filter">
                      <Accordion.Body>
                        <DataFilter
                          filterData={reports}
                          setFilterData={setCollectionReport}
                          filterOptions={filterOptions}
                          setFilterOption={setFilterOption}
                          inputPermission={filterInputPermission}
                        />
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <div className="collectorWrapper pb-2">
                    <div className="table-section">
                      <Table
                        isLoading={isLoading}
                        columns={columns}
                        data={collectionReport}
                      />
                    </div>
                  </div>
                </div>
              </FourGround>
              <Footer />
            </FontColor>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResellerBillCollection;
